import React from 'react';
import { Icon, Tab, Tabs } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { TaskManager, OccupationCalendarManager, TaskPlans, TaskOverview } from '../../components';
import UsersPage from '../UsersPage';

const sections = [
  { route: 'performance', label: 'f-tasks-performance', icon: 'bar_chart' },
  { route: 'overview', label: 'f-tasks-overview', icon: 'checklist' },
  { route: 'planning', label: 'f-tasks-planning', icon: 'calendar_today' },
  { route: 'employees', label: 'f-tasks-employees', icon: 'people_outline' },
  { route: 'occupation', label: 'f-tasks-occupation', icon: 'date_range', disabled: true }
];

const TasksExecution: React.FC = () => {
  const { option } = useParams<{ option: string }>();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const tab = Math.max(
    0,
    sections.findIndex((section) => section.route === option)
  );

  return (
    <div className="box-border mx-auto w-full min-w-0 max-w-[1680px] px-3 pb-8 text-slate-800 sm:px-6 lg:px-8">
      <header className="mb-6 flex items-start gap-3">
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-indigo-50 text-indigo-700">
          <Icon aria-hidden="true">assignment</Icon>
        </span>
        <div>
          <h1 className="m-0 text-2xl font-semibold tracking-tight text-slate-900">{t('f-tasks')}</h1>
          <p className="mt-1 mb-0 text-sm text-slate-500">
            {t('f-task-workspace-description', 'Plan farm work, coordinate your team and follow daily progress.')}
          </p>
        </div>
      </header>
      <Tabs
        value={tab}
        onChange={(_event, value) => navigate('/tasks-execution/' + sections[value].route)}
        variant="scrollable"
        scrollButtons="auto"
        aria-label={t('f-tasks')}
        className="!mb-6 !border-b !border-slate-200 [&_.MuiTabs-indicator]:!bg-indigo-600"
      >
        {sections.map((section, index) => (
          <Tab
            key={section.route}
            id={section.route + 'Tab'}
            aria-controls={'task-panel-' + index}
            disabled={section.disabled}
            className="!min-h-[52px] !px-5 !normal-case !text-sm/none !font-medium [&.Mui-selected]:!text-indigo-700"
            label={
              <span className="flex items-center gap-2">
                <Icon className="!text-lg/none">{section.icon}</Icon>
                {t(section.label)}
              </span>
            }
          />
        ))}
      </Tabs>
      <section
        role="tabpanel"
        id={'task-panel-' + tab}
        aria-labelledby={sections[tab].route + 'Tab'}
        className="min-w-0 rounded-xl border border-slate-200 bg-white p-4 sm:p-6 [&_.MuiButton-root]:!normal-case [&_.MuiButton-root]:!shadow-none"
      >
        {tab === 0 && <TaskOverview />}
        {tab === 1 && <TaskPlans />}
        {tab === 2 && <TaskManager />}
        {tab === 3 && <UsersPage />}
        {tab === 4 && <OccupationCalendarManager />}
      </section>
    </div>
  );
};

export default TasksExecution;
